export default {"src":"/_next/static/media/palm_24.eee3a8a7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};